// src/utils/imageToBase64.ts
export const imageToBase64 = async (imagePath: string): Promise<string> => {
  return new Promise(async (resolve) => {
    const response = await fetch(imagePath);
    const imageBlob = await response.blob();

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result as string;
      console.log('base?????', base64);
      if (base64) resolve(base64);
    };

    reader.readAsDataURL(imageBlob);
  });
};
